export var Module;
(function (Module) {
    Module["Sidebar"] = "sidebar";
    Module["RuntimeSidebar"] = "runtimeSidebar";
    Module["VersionPublish"] = "versionPublish";
    Module["EntityUpdateTip"] = "entityUpdateTip";
    Module["LimitReport"] = "limitReport";
    Module["ConvertToAi"] = "convertToAi";
    Module["Skill"] = "skill";
    Module["Knot"] = "knot";
    Module["GogoRemote"] = "gogoRemote";
})(Module || (Module = {}));
